/**
 * Token storage backed by browser sessionStorage.
 * Uses `sessionStorage` per spec #99 spirit (per-tab isolation).
 */
const TOKEN_KEY = 'fra_admin_session';

export interface StoredSession {
  accessToken: string;
  refreshToken: string;
  expiresAt: string;
  userId: string;
  username: string;
  role: string;
}

export const tokenStorage = {
  get(): StoredSession | null {
    try {
      const raw = sessionStorage.getItem(TOKEN_KEY);
      if (!raw) return null;
      const session = JSON.parse(raw) as StoredSession;
      if (new Date(session.expiresAt) <= new Date()) {
        sessionStorage.removeItem(TOKEN_KEY);
        return null;
      }
      return session;
    } catch {
      return null;
    }
  },

  set(session: StoredSession): void {
    sessionStorage.setItem(TOKEN_KEY, JSON.stringify(session));
  },

  clear(): void {
    sessionStorage.removeItem(TOKEN_KEY);
  },
};
